import { CommandAPI } from './types'

export const API_OPTIONS: CommandAPI[] = [
  {
    label: 'Reboot Instance',
    value: 'aes/domain/dp/node/reboot-instance',
    description: 'Reboot the selected instance'
  },
  {
    label: 'Deactivate Elasticsearch',
    value: 'aes/domain/dp/node/es/deactivate',
    description: 'Deactivate elasticsearch for the instance'
  },
  {
    label: 'Activate Elasticsearch',
    value: 'aes/domain/dp/node/es/activate',
    description: 'Activate elasticsearch for the instance'
  },
  {
    label: 'Pre-activate Elasticsearch',
    value: 'aes/domain/dp/node/es/preactivate',
    description: 'Prepare instance for elasticsearch'
  },
  {
    label: 'Deactivate Domain Maintenance',
    value: 'aes/domain/dp/node/domain-maintenance/deactivate',
    description: 'Deactivate maintenance mode for the domain'
  },
  {
    label: 'Activate Domain Maintenance',
    value: 'aes/domain/dp/node/domain-maintenance/activate',
    description: 'Activate maintenance mode for the domain'
  },
  {
    label: 'Pre-activate Domain Maintenance',
    value: 'aes/domain/dp/node/domain-maintenance/preactivate',
    description: 'Prepare domain for maintenance mode'
  }
];

